import {
  BorderProps,
  Box as ChakraBox,
  BoxProps as ChakraBoxProps,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'

// Todo: Allow any string until we come up
// with acceptable colors for existing component
type BoxProps = {
  backgroundColor?: string
  bg?: string
  bgColor?: string
} & SwashbuckleComponentProps<ChakraBoxProps> &
  BorderProps

export const Box = ({
  'data-qa': dataQa,
  className,
  ...chakraBoxProps
}: BoxProps) => {
  return (
    <ChakraBox data-qa={dataQa} className={className} {...chakraBoxProps} />
  )
}

Box.displayName = 'Box'
